/**
 * @file Toast atom — transient notification overlay family.
 * @description structured atom: compound parts re-exported from the vendored
 * Gluestack family; this is the only sanctioned import path for app code
 * (RFC §3).
 * @module components/atoms/Toast
 */
export {
  useToast,
  Toast,
  ToastTitle,
  ToastDescription,
} from "@/components/ui/toast";
